var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    x: "0px",
    y: "0px",
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAQAAADB7vUKAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElNRQfkAw0RIzEGWO8lAAAAyklEQVQY03XOsSvEARjG8ed3NyiEXYmSZFXcH2ChfjZl9j/cwEBW6/0DMuk2pZTVeDIrcYPIeMt1neVj0d3vlPeZ3u/79O0tJEnSyGG2s5G5JI9ppZ/PPGWYRCy5MgAD77ou3Dj3pWNHYlcX3DnSsGLRnp5SD0MncYlnpbr8pu3VtFXXeIsFp5ZHx1g31FYXNU2b8TdnOB7vtYynSDKbMslHhY66hUIcoGdrbJjUT+ngxfx/hX3wUGXVH5J+vpPcT7AJw4yWW2tV9gNPPsP2nnSEbgAAAABJRU5ErkJggg=="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeed);
export default __webpack_public_path__ + "static/media/speed.8c66da8afa07e428d426022031da7e0a.svg";
export { ForwardRef as ReactComponent };